<script>
  export let default_val;
  export let var_name;
  export let update;
  export let label;
</script>

{label}
<input bind:value={default_val} on:change="{(e) => {
  default_val = e.target.value;
  update(var_name, e.target.value);
}}"/>
